import { Phone, MapPin } from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const FloatingContactButton = () => {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-4">
      {/* Location Button */}
      <a
        href="https://maps.google.com/?q=Αμύντα+18+Θεσσαλονίκη"
        target="_blank"
        rel="noopener noreferrer"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 1.2, type: "spring", stiffness: 260, damping: 20 }}
        >
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            className="relative flex items-center justify-center w-14 h-14 rounded-full bg-secondary text-secondary-foreground shadow-lg hover:shadow-xl transition-shadow"
            aria-label="Τοποθεσία"
          >
            <MapPin className="w-6 h-6" aria-hidden="true" />
          </motion.button>
        </motion.div>
      </a>

      {/* Phone Button */}
      <Link to="/contact">
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 1, type: "spring", stiffness: 260, damping: 20 }}
        >
          {/* Pulse rings */}
          <span className="absolute inset-0 rounded-full bg-primary/30 animate-ping" />
          <span 
            className="absolute inset-0 rounded-full bg-primary/20 animate-ping" 
            style={{ animationDelay: "0.5s" }} 
          />
          
          {/* Button */}
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            className="relative flex items-center justify-center w-14 h-14 rounded-full bg-primary text-primary-foreground shadow-lg hover:shadow-xl transition-shadow"
            aria-label="Επικοινωνία"
          >
            <Phone className="w-6 h-6" aria-hidden="true" />
          </motion.button>
        </motion.div>
      </Link>
    </div>
  );
};

export default FloatingContactButton;
